import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import PageTemplate from '../../../components/template/PageTemplate';
import NoticeStoreSaveContainer from '../../../containers/notice/NoticeStoreSaveContainer';
import { noticeStoreActions } from '../../../store/modules/notice/store';
import { NOTICE_STORE_PAGE_NAME } from '../../../constants/service/app/noticeStoreConstants';

const NoticeStoreEdit = (props) => {
  const { getNoticeStore, editNoticeStore } = props;
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getNoticeStore({
        storeNoticeId: Number(id),
      });
    }
  }, [id, getNoticeStore]);

  return (
    <PageTemplate pageName={NOTICE_STORE_PAGE_NAME.NOTICE_STORE_EDIT}>
      <NoticeStoreSaveContainer
        pageName={NOTICE_STORE_PAGE_NAME.NOTICE_STORE_EDIT}
        isEdit
        storeNoticeId={id}
        onSubmit={editNoticeStore}
      />
    </PageTemplate>
  );
};

const mapDispatchToProps = {
  getNoticeStore: noticeStoreActions.getNoticeStore,
  editNoticeStore: noticeStoreActions.editNoticeStore,
};

export default connect(null, mapDispatchToProps)(NoticeStoreEdit);
